// Tiny scale helpers for the inline SVG charts (Section 24.14: no chart library at v1).

/** A clean step (1, 2 or 5 x 10^n) giving about `count` ticks over [min, max]. */
export function niceTicks(min: number, max: number, count = 3): number[] {
  if (!Number.isFinite(min) || !Number.isFinite(max)) return [0];
  if (max - min < 1e-9) return [min];
  const raw = (max - min) / count;
  const power = 10 ** Math.floor(Math.log10(raw));
  const step = [1, 2, 5, 10].map((m) => m * power).find((s) => s >= raw) ?? raw;
  const out: number[] = [];
  for (let v = Math.ceil(min / step) * step; v <= max + step * 1e-6; v += step)
    out.push(Math.round(v / step) * step);
  return out;
}

/** The y-domain for a series: from 0 (or the minimum if negative) to a little above the max. */
export function domainOf(values: readonly number[], floorAtZero = true): [number, number] {
  if (values.length === 0) return [0, 1];
  let lo = Math.min(...values);
  let hi = Math.max(...values);
  if (floorAtZero && lo > 0) lo = 0;
  if (hi - lo < 1e-9) hi = lo + 1;
  return [lo, hi + (hi - lo) * 0.08];
}

export function linear(d0: number, d1: number, r0: number, r1: number): (x: number) => number {
  const span = d1 - d0 === 0 ? 1 : d1 - d0;
  return (x) => r0 + ((x - d0) / span) * (r1 - r0);
}

export function pathOf(points: readonly [number, number][]): string {
  return points.map(([x, y], i) => `${i === 0 ? 'M' : 'L'}${x.toFixed(1)},${y.toFixed(1)}`).join('');
}
